import { useNavigate, useParams } from "react-router-dom";
import { useAgendamentoStepIndicator } from "../../../hooks/useAgendamentoStepIndicator";
import { useAgendamentoPorId } from "../../../hooks/queries/agendamento/useAgendamentoPorId/useAgendamentoPorId";
import { useVincularVeiculoPrimeiroRegistro } from "../../../hooks/queries/agendamento/useVincularVeiculoPrimeiroRegistro/useVincularVeiculoPrimeiroRegistro";
import { useContextSite } from "../../../context/Context";
import { Tracking } from "../../../services/Tracking";
import { getTipoVeiculoCode, TipoVeiculoEnumType } from "../../../enums/tipoVeiculo";
import { IFormVehicleRegisterV2Values } from "../../Molecules/FormVehicleRegisterV2/useFormVehicleRegisterV2";

export const useVehicleRegisterV2 = () => {
  const navigate = useNavigate();
  const { uuidAgendamento } = useParams();
  const stepIndicator = useAgendamentoStepIndicator();
  const { setIsLoad } = useContextSite();

  const { data: agendamento } = useAgendamentoPorId(uuidAgendamento ?? "");
  const { mutate: vincularVeiculoPrimeiroRegistro } =
    useVincularVeiculoPrimeiroRegistro();

  function handleSubmit(data: IFormVehicleRegisterV2Values) {
    setIsLoad(true);

    vincularVeiculoPrimeiroRegistro(
      {
        uuidAgendamento: agendamento?.uuid ?? uuidAgendamento ?? "",
        veiculoForm: {
          modelo: data.modelo,
          ano: data.ano,
          placa: data.placa,
          chassi: data.chassi,
          tipo: getTipoVeiculoCode(data.tipo as TipoVeiculoEnumType),
        },
      },
      {
        onSuccess: ({ data: agendamentoAtualizado }) => {
          navigate(
            `/agendamento/${uuidAgendamento}/servicos/veiculo?uuidVeiculo=${agendamentoAtualizado?.veiculo?.uuid}`,
          );
        },
        onError: ({
          response: {
            data: { mensagem },
          },
        }: any) => {
          Tracking.error(
            "mapa:agendamento/servicos/primeiro-registro:cadastrar-veiculo-falhou",
            { mensagem },
          );
        },
        onSettled: () => setIsLoad(false),
      },
    );
  }

  return { stepIndicator, handleSubmit };
};
